import errorCodes from "./error-codes";
import i18n from "../../public/lang/index";
import { Message } from "element-ui";

// 部分code不需要顯示錯誤碼
const excludeCodes = [
  "CAPTCHA_HAS_EXPIRED",
  "CAPTCHA_VERIFY_FAILED",
  "CAPTCHA_NOT_FOUND",
  "CAPTCHA_IS_MISMATCH",
];

// 處理錯誤消息和默認消息的翻譯
const errorMessageHandler = (code, message, defaultMessage) => {
  // 如果錯誤代碼在 errorCodes 中存在，則獲取翻譯後的消息；否則使用message或默認消息，包含(錯誤代碼)
  let translatedMessage = errorCodes[code] ? i18n.t(errorCodes[code]) : code ? message : defaultMessage;
  return `${translatedMessage}${code && !excludeCodes.includes(code) && !translatedMessage.startsWith('E-') ? ` (${code})` : ''}`;
};

// 根據HTTP狀態碼處理特定類型的錯誤
const handleHttpStatusError = (error, status, defaultMessage) => {
  console.log(error, status, defaultMessage);
  if (error.status === status) {
    const code = error.code || "";
    throw errorMessageHandler(code, error.message, defaultMessage);
  }
};

let plugin = {
  install: (Vue) => {
    Vue.prototype.$error = (error) => {
      try {
        if (typeof error === "string") {
          throw error;
        } else if (typeof error === "object") {
          if (error.status) {
            if (error.status === 401) {
              return;
            }
            handleHttpStatusError(error, 400, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
            handleHttpStatusError(error, 404, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
            handleHttpStatusError(
              error,
              403,
              error.code === "ACCESS_DENIED"
                ? i18n.t("message.ErrorMessage.ACCESS_DENIED")
                : error.code === "FORBID_IDENTITY_TYPE"
                  ? i18n.t("message.ErrorMessage.FORBID_IDENTITY_TYPE")
                  : i18n.t("message.ErrorMessage.SYSTEM_BUSY")
            );
            handleHttpStatusError(error, 409, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
            handleHttpStatusError(error, 500, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
            handleHttpStatusError(error, 504, i18n.t("message.ErrorMessage.GATEWAY_TIME_OUT"));

            if (error.message?.indexOf("Cannot read properties") !== -1) {
              throw errorMessageHandler("", error.message, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
            }
          } else if (error.message) {
            throw error.message;
          }
        }

        throw errorMessageHandler("", error.code, i18n.t("message.ErrorMessage.SYSTEM_BUSY"));
      } catch (errorMessage) {
        Message.error({
          message: errorMessage,
          duration: 5000,
        });
      }
    };
  },
};

export default plugin;
